// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/tableColumns/planWithLogoColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import translateX from 'utils/translateX';
import SimpleAvatar from 'components/SimpleComponents/SimpleAvatar';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function planWithLogoColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'plan',
    dataIndex = 'name',
    width,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    className: 'text-truncate',
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const op = r?.__operator;
      const planId = r?._integrations?.planId;
      const planName = r?._integrations?.originalName;

      return (
        <div
          className="avatar-with-border d-flex align-items-center"
          style={{ gap: 10, minWidth: 0 }}
        >
          <SimpleAvatar
            src={op?.avatar?.base64Thumb}
            name={op?.name}
            size={48}
            shape="square"
            showShadow={false}
            backColor={op?.backColor}
            foreColor={op?.foreColor}
          />
          <div style={{ minWidth: 0, flex: 1, lineHeight: 1.4 }}>
            <Tooltip title={r?.name}>
              <span className="font-weight-semibold text-truncate d-block">{r?.name || '—'}</span>
            </Tooltip>
            {planId && (
              <div className="text-muted text-uppercase" style={{ fontSize: 12 }}>
                {planId} - {planName}
              </div>
            )}
          </div>
        </div>
      );
    },
  };
}

export default planWithLogoColumn;
